import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { ToolsService } from '../providers/tools.service';

@Injectable()
export class MainGuard {
  constructor(
    private router: Router,
    public tools: ToolsService
  ) {}

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> | Promise<boolean> | boolean {
    return true; // testing
    let auth = !!localStorage.getItem('companyID');
    if (auth) {
      return true;
    } else {
      this.router.navigate(['account/login']);
      return false;
    }
  }
}
